import { Banner, CardItem, HorizontalWordLoop } from '@/components'
import { CTA } from '@/components/CTA'
import { Fade, JackInTheBox, Slide } from "react-awesome-reveal";
import { windowWidth } from '@/services/services';
import { useSelector } from 'react-redux';
import { RootState, store } from '@/store/store';
import { getStorageImagePath } from '@/utils/utils';
import { SeoTags } from '@/components/SeoTags';

export const About = () => {

    const appConfig = useSelector((state: RootState) => state.app.config);
    const page = appConfig?.about

    if (!page) return


    return (
        <>
            <SeoTags
                page={page}
                seo_settings={store.getState().app.config.seo_settings}
            />
            
            <JackInTheBox triggerOnce={true} delay={1000}>
                <Banner
                    subtitle={page?.page?.banner_intro_text}
                    title={page?.page?.banner_title}
                    image={getStorageImagePath(JSON.parse(page?.page?.banner_image ?? {}))}
                    description={page?.page?.banner_subtitle}
                />
            </JackInTheBox>
            <div className="   container pt-lg-5 ">
                <div className="row justify-content-center pt-5">
                    <div className="col-lg-3 mt-2">
                        <Fade triggerOnce={true} delay={200}><h2 className="sub-title text-white">{page?.page?.section_title_left}</h2></Fade>
                    </div>
                    <div className="col-lg-9">
                        <Fade triggerOnce={true} delay={400}><h3 className='text-white stroke-animation' dangerouslySetInnerHTML={{ __html: page?.page?.section_title_right }}></h3></Fade>
                        <Fade triggerOnce={true} delay={600}>
                            <p className="text-white mt-2 fs-30">
                                {page.page?.section_text_1}
                            </p>
                        </Fade>
                        <Fade triggerOnce={true} delay={750}>
                            <p className="text-white mt-3 fs-30">
                                {page.page?.section_text_2}
                            </p>
                        </Fade>
                        <Fade triggerOnce={true} delay={900}>
                            <p className="text-white mt-3 fs-30">
                                {page.page?.section_text_3}
                            </p>
                        </Fade>
                        <Fade triggerOnce={true} delay={1050}>
                            <p className="mt-3 text-primary fs-30">
                                <b>{page.page?.section_text_4}</b>
                            </p>
                        </Fade>
                    </div>
                </div>

            </div>
            <Fade triggerOnce={true} delay={100}>
                <HorizontalWordLoop title={"ABOUT US"} />
            </Fade>
            <div className="container pb-5">
                <div className="row">
                    <div className="col-lg-12">
                        <Slide delay={0}><h2 className='text-white pb-4'>{page.page?.card_section_title}</h2></Slide>
                    </div>
                    {page?.cards?.map((card, index) => <div className="col-lg-4 col-md-6 pt-3 pb-2">
                        <CardItem
                            delay={index == 0 || windowWidth <= 1 ? 1000 : (1000 + 200 * index)}
                            icon={card?.icon}
                            title={card?.title}
                            text={card?.text}
                        />
                    </div>)}
                </div>

            </div>

            <CTA
                image={getStorageImagePath(JSON.parse(page?.page?.cta_image ?? {}))}
                title={page?.page?.cta_title}
                description={page?.page?.cta_description} />
        </>
    )
}
